var _path, _rect, _path2, _rect2, _path3, _rect3, _polygon, _rect4, _polygon2, _rect5, _polygon3, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0v233.739h233.739V0H0z M200.348,200.348H33.391V33.391h166.957V200.348z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.783,
    y: 66.783,
    width: 100.174,
    height: 100.174
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.261,0v233.739H512V0H278.261z M478.609,200.348H311.652V33.391h166.957V200.348z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 345.043,
    y: 66.783,
    width: 100.174,
    height: 100.174
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,278.261V512h233.739V278.261H0z M200.348,478.609H33.391V311.652h166.957V478.609z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.783,
    y: 345.043,
    width: 100.174,
    height: 100.174
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "345.043,311.652 345.043,278.261 278.261,278.261 278.261,512 345.043,512 345.043,478.609 311.652,478.609  311.652,411.826 345.043,411.826 345.043,378.435 311.652,378.435 311.652,311.652  "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 478.609,
    y: 278.261,
    width: 33.391,
    height: 33.391
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "478.609,356.174 478.609,478.609 445.217,478.609 445.217,512 512,512 512,356.174  "
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 378.435,
    y: 278.261,
    width: 66.783,
    height: 33.391
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.217,378.435 445.217,345.043 378.435,345.043 378.435,445.217 445.217,445.217 445.217,411.826  411.826,411.826 411.826,378.435  "
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 378.435,
    y: 478.609,
    width: 33.391,
    height: 33.391
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QRCode.8e7ddf42416d2ee404236af924af3869.svg";
export { ForwardRef as ReactComponent };